import React from 'react';
import styles from './DocPage.styl'
import Image from './ui/features/Image.jsx';
import Button from './ui/button/Button.jsx'
import GroundLightVersion from './ui/features/Version/GroundLightVersion.jsx'

const DocPage = ({onNavConfigurator}) => {

	const co = () => {
		window.open('https://www.iek.ru/upload/medialibrary/c13/so-153_34.21.122_2003.pdf', '_blank')
	}
	const rd = () => {
		window.open('https://www.iek.ru/upload/medialibrary/d5d/rd-34.21.122_87.pdf', '_blank')
	}


	const onBackToNav = () => {
		onNavConfigurator()
	}

	return(<div className={styles.cfg}>
		{/*Белый фон и лого*/}
		<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '18%', height: '80px'}}/>
		<Image
			className={styles.logo}
			blockChangeScale={true}
		/>
		{/*Оранжевый фон заголовка*/}
		<div style={{margin: '0 auto', backgroundColor: '#ffcc3f', width: '100%', height: '80px'}}>
			<div className={styles.title}>Техническая документация</div>
		</div>

		<div style={{
			position: 'absolute',
			margin: '0 auto',
			backgroundColor: '#fff',
			width: '740px',
			height: '590px',
			top: '100px',
			left: '20px'
		}}>
			<div className={styles.sectionTitle} style={{
				position: 'absolute',
				margin: '0 auto',
				top: '20px',
				left: '20px'
			}}>
				<p style={{
					minWidth: '500px',
					lineHeight:'1.3rem'
				}}>
					СО 153-34.21.122-2003 "ИНСТРУКЦИЯ ПО УСТРОЙСТВУ МОЛНИЕЗАЩИТЫ ЗДАНИЙ, СООРУЖЕНИЙ И ПРОМЫШЛЕННЫХ КОММУНИКАЦИЙ"
				</p>
				<div style={{
					borderLeft: '5px solid #eee',
					height: '50px',
					marginLeft: '10px'
				}}><Button
					x="25"
					y="81"
					buttonStyle={styles.mainBtn}
					textStyle={styles.mainBtnText}
					iconStyle={styles.pdfBtnIcon}
					text="Скачать документацию"
					onClick={co}
					key="doc"
				/></div>


			</div>

			<div className={styles.sectionTitle} style={{
				position: 'absolute',
				margin: '0 auto',
				top: '150px',
				left:'20px'
			}}>
						<p style={{
							minWidth: '500px',
						}}>
							ИНСТРУКЦИЯ ПО УСТРОЙСТВУ МОЛНИЕЗАЩИТЫ ЗДАНИЙ И СООРУЖЕНИЙ РД 34.21.122-87
						</p>
				<div style={{
					borderLeft: '5px solid #eee',
					height: '50px',
					marginLeft: '10px'
				}}><Button
					x="25"
					y="55"
					buttonStyle={styles.mainBtn}
					textStyle={styles.mainBtnText}
					iconStyle={styles.pdfBtnIcon}
					text="Скачать документацию"
					onClick={rd}
					key="doc"
				/></div>


			</div>
		</div>

		<Button
			x="20"
			y="710"
			buttonStyle={styles.mainBtn}
			textStyle={styles.mainBtnText}
			iconStyle={styles.pdfBtnIcon}
			text="Главное меню"
			onClick={onBackToNav}
			key="groundCalc"
		/>

		{/*onOpenGroundCalc*/}

		{/*Нижняя плашка*/}
		{/* На основной сайт IEK */}
		<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '760px'}}/>
		<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>
		<span className={styles.feedBack}>Почта для связи: kiselevav@iek.ru</span>
		<div style={{
			position: 'absolute',
			top: '765px',
			left: '730px',
			zIndex: '15'
		}}>
			<GroundLightVersion />
		</div>
		{/* Техническая поддержка */}
		<div style={{
			position: 'absolute',
			backgroundColor: '#ffcc3f',
			width: '50%',
			height: '20px',
			top: '760px',
			left: '390px'
		}}/>
		<a style={{
			position: 'absolute',
			top: '763px',
			left: '145px',
			color: '#3c4e50',
			width: '141px',
			height: '14px'
		}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
		</a>
		<span className={styles.techSupport}>+7 (495) 542-22-27</span>

	</div>)

}

export default DocPage



// WEBPACK FOOTER //
// ./src/react/DocPage.jsx